/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Обший вид формы сообщения
   */
  app.MessageFormView = app.FormView.extend({
    modelName: 'Message',
    sent: false,
    initiatorSelector: '',
    
    events: {
      'click .button': 'save'
    },
    
    /**
     * Закрытие формы
     */
    close: function () {
      this.$('.js-popup-close').click();
    },
    
    /**
     * Сохранение модели.
     */
    save: function () {
      var model = this.modelName,
        attributes = {type: this.type};
      if (!this.sent) {
        this.sent = true;
        this.model = new app[model]();
        
        this.$fields.each(function () {
          attributes[this.name] = $(this).val();
        });
        
        this.model.save(attributes, {
            'success': this.success.bind(this),
            'error': this.error.bind(this)
          }
        );
      }
    },
    
    /**
     * Успешное сохранение модели
     */
    success: function () {
      this.clearErrors();
      this.$fields.each(function () {
        $(this).val('');
      });
      this.close();
      this.sent = false;
      this.successAfter();
    },
    
    error: function () {
      this.sent = false;
      app.FormView.prototype.error.apply(this, arguments);
    },
    
    /**
     * При успешной отправке сообщения, создаем окно с сообщением об этом.
     */
    successAfter: function () {
      new app.DynamicPopupView({
        className: 'callme-send-success',
        initiator: $(this.initiatorSelector),
        content: 'Ваше сообщение отправлено'
      });
    }
  });
})(jQuery);

}.call(window));